import { ProductApiDto } from '@b2x/storefront-api-js-client/src/dto';

import { RecommendedCartProductTileA } from './RecommendedCartProductTileA';
import { PropsWithCustomComponent, VariantsController } from './VariantsController';

export interface RecommendedCartProductTileProps {
  product: ProductApiDto;
}

export type RecommendedCartProductTileVariants = 'A';

const RecommendedCartProductTileController = (props: PropsWithCustomComponent<RecommendedCartProductTileProps>) => (
  <VariantsController<RecommendedCartProductTileProps, RecommendedCartProductTileVariants>
    {...props}
    variantsControllerConfig={{
      componentVariants: { A: RecommendedCartProductTileA },
      name: 'RecommendedCartProductTile',
    }}
  />
);
export { RecommendedCartProductTileController as RecommendedCartProductTile };
